export const getHost = (): string => {
  const domain = window.location.hostname;

  if (domain.includes('localhost')) {
    return 'americafirstleads';
  }

  if (window.location.href.includes('americafirstleads')) {
    return 'americafirstleads';
  }

  return domain.split('.')[1];
};

export const getImageUrl = (imageName: string): string => {
  return `https://s3.amazonaws.com/docs.sonicwebdev.com/images/${getHost()}/${imageName}`;
};

export default getHost;
